<template>
  <DropdownMenuRoot v-model:open="isOpen">
    <DropdownMenuTrigger>
      <div
        class="flex items-center justify-center bg-fill-brand rounded-full size-10 cursor-pointer"
      >
        <Icon icon="material-symbols:edit" class="size-6" />
      </div>
    </DropdownMenuTrigger>

    <DropdownMenuPortal>
      <DropdownMenuContent
        class="outline-none shadow bg-surface-hover backdrop-blur-3xl p-2 rounded-xl will-change-[opacity,transform] data-[side=top]:animate-slideDownAndFade data-[side=right]:animate-slideLeftAndFade data-[side=bottom]:animate-slideUpAndFade data-[side=left]:animate-slideRightAndFade min-w-60 z-50 font-sans text-white text-sm"
        :side-offset="5"
      >
        <DropdownMenuItem
          class="flex items-center select-none outline-none data-[highlighted]:bg-surface-hover rounded-md px-2 py-1 gap-2 cursor-pointer"
          @click="onEditLeaderboard"
        >
          <Icon icon="material-symbols:leaderboard" class="size-4" />
          {{ $t("adminLeaderboard.popOver.editLeaderboard") }}
        </DropdownMenuItem>

        <DropdownMenuItem
          v-if="userStore.isSystemAdmin"
          class="flex items-center select-none outline-none data-[highlighted]:bg-surface-hover rounded-md px-2 py-1 gap-2 cursor-pointer"
          @click="onActionPoints"
        >
          <Icon icon="material-symbols:paid" class="size-4" />
          {{ $t("adminLeaderboard.popOver.actionPoints") }}
        </DropdownMenuItem>

        <DropdownMenuItem
          v-if="channelStore.permissions.manageChannel"
          class="flex items-center select-none outline-none data-[highlighted]:bg-surface-hover rounded-md px-2 py-1 gap-2 cursor-pointer"
          @click="onChannelActions"
        >
          <Icon icon="material-symbols:settings" class="size-4" />
          {{ $t("adminLeaderboard.popOver.channelActions") }}
        </DropdownMenuItem>

        <DropdownMenuItem
          class="flex items-center select-none outline-none data-[highlighted]:bg-surface-hover rounded-md px-2 py-1 gap-2 cursor-pointer"
          @click="onRewardUser"
        >
          <Icon icon="material-symbols:military-tech" class="size-4" />
          {{ $t("adminLeaderboard.popOver.rewardUser") }}
        </DropdownMenuItem>

        <DropdownMenuArrow class="fill-brand-bgdivider-20 backdrop-blur-3xl" />
      </DropdownMenuContent>
    </DropdownMenuPortal>
  </DropdownMenuRoot>

  <LeaderboardEdit v-model:is-open="isEditLeaderboardOpen" />
  <ActionPointsEdit
    v-if="userStore.isSystemAdmin"
    v-model:is-open="isActionPointsOpen"
  />
  <ChannelActionsEdit
    v-if="channelStore.permissions.manageChannel"
    v-model:is-open="isChannelActionsOpen"
  />
  <RewardUser v-model:is-open="isRewardUserOpen" />
</template>

<script setup lang="ts">
import { ref } from "vue";
import { Icon } from "@iconify/vue";
import {
  DropdownMenuArrow,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuPortal,
  DropdownMenuRoot,
  DropdownMenuTrigger,
} from "reka-ui";
import LeaderboardEdit from "./leaderboard-edit.vue";
import ActionPointsEdit from "./action-points-edit.vue";
import ChannelActionsEdit from "./channel-actions-edit.vue";
import RewardUser from "./reward-user.vue";
import { useUserStore } from "@/stores/user.store";
import { useChannelStore } from "@/stores/channel.store";

const isOpen = ref(false);
const isEditLeaderboardOpen = ref(false);
const isActionPointsOpen = ref(false);
const isChannelActionsOpen = ref(false);
const isRewardUserOpen = ref(false);

const userStore = useUserStore();
const channelStore = useChannelStore();

const onEditLeaderboard = () => {
  isOpen.value = false;
  isEditLeaderboardOpen.value = true;
};

const onActionPoints = () => {
  isOpen.value = false;
  isActionPointsOpen.value = true;
};

const onChannelActions = () => {
  isOpen.value = false;
  isChannelActionsOpen.value = true;
};

const onRewardUser = () => {
  isOpen.value = false;
  isRewardUserOpen.value = true;
};
</script>
